<p *ngIf="!filterable && !sortable && !searchable" class="header-title">
  {{ title }}
</p>
<ps-ui-select-dropdown
  #dropdown
  *ngIf="sortable || searchable || filterable"
  field="text"
  [idField]="'text'"
  [multi]="multi"
  [groups]="groups"
  [dropdownItems]="filterable ? items : []"
  [label]="title"
  [labelAlignment]="textAlignment"
  [truncateWord]="truncateWord"
  [enableSearch]="searchable"
  [indicator]="true"
  [maxHeight]="200"
  [searchDropdownItems]="searchDropdownItems"
  [showClearStateButton]="clearFilterButton"
  [searchTerm]="searchText"
  (clearState)="clearState()"
  (search)="onSearch($event)"
  [loading]="false"
  [formControl]="filters"
  (selectedItems)="onFilter($event)"
  (selectedItem)="onFilter([$event])"
>
  <ng-template psUiSelectDropdownIcon>
    <i *ngIf="sorted === 'none'" class="fa fa-sort" aria-hidden="true"></i>
    <i
      *ngIf="sorted === 'ascending'"
      class="fa fa-sort-asc"
      aria-hidden="true"
    ></i>
    <i
      *ngIf="sorted === 'descending'"
      class="fa fa-sort-desc"
      aria-hidden="true"
    ></i>
  </ng-template>

  <ng-template psUiSelectDropdownAction [enabled]="sortable">
    <button
      psUiButton
      [outline]="true"
      [size]="'small'"
      class="p-0"
      type="button"
      [ngClass]="{ 'btn-primary': sorted === 'ascending' }"
      (click)="onSort('ascending'); dropdown.toggle()"
    >
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
    <button
      psUiButton
      [outline]="true"
      [size]="'small'"
      class="p-0"
      type="button"
      [ngClass]="{ 'btn-primary': sorted === 'descending' }"
      (click)="onSort('descending'); dropdown.toggle()"
    >
      <i class="fa fa-arrow-down" aria-hidden="true"></i>
    </button>
  </ng-template>
</ps-ui-select-dropdown>
